import BillingsOrderForwardTaxiTaxiRecalculateRequest, {
  BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType,
  BillingsOrderForwardTaxiTaxiRecalculateRequestContribution,
  BillingsOrderForwardTaxiTaxiRecalculateRequestNode,
} from "../../../../../api/raily/billings/order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate.request";
import BillingsOrderForwardTaxiTaxiRecalculateParams, {
  BillingsOrderForwardTaxiTaxiRecalculateParamsContribution,
  BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType,
  BillingsOrderForwardTaxiTaxiRecalculateParamsNode,
} from "./billings-order-forward-taxi-taxi-recalculate-params";

const createContributionType = (
  type:
    | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.BONUS_OTHER
    | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_WRONG_ROUTE
    | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_BEING_LATE
    | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR
    | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_OTHER,
):
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.BONUS_OTHER
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_WRONG_ROUTE
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_BEING_LATE
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_INCOMPATIBLE_CAR
  | BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_OTHER => {
  switch (type) {
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.BONUS_OTHER:
      return BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.BONUS_OTHER;
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_BEING_LATE:
      return BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_BEING_LATE;
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
      return BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_INCOMPATIBLE_CAR;
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_OTHER:
      return BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_OTHER;
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_WRONG_ROUTE:
      return BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.PENALTY_WRONG_ROUTE;
  }
};

const createContribution = (
  contribution: BillingsOrderForwardTaxiTaxiRecalculateParamsContribution,
): BillingsOrderForwardTaxiTaxiRecalculateRequestContribution => {
  switch (contribution.type) {
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.BONUS_FAVORABLE_DISTANCE:
      return {
        type: BillingsOrderForwardTaxiTaxiRecalculateRequestContributionType.BONUS_FAVORABLE_DISTANCE,
        comment: contribution.comment,
        distance: contribution.distance,
        rate: contribution.rate,
      };
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.BONUS_OTHER:
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_BEING_LATE:
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_OTHER:
    case BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_WRONG_ROUTE:
      return {
        type: createContributionType(contribution.type),
        comment: contribution.comment,
        amount: contribution.amount,
      };
  }
};

const createContributions = (
  contributions: BillingsOrderForwardTaxiTaxiRecalculateParamsContribution[],
): BillingsOrderForwardTaxiTaxiRecalculateRequestContribution[] => {
  return contributions.map(createContribution);
};

const createNode = (
  node: BillingsOrderForwardTaxiTaxiRecalculateParamsNode,
): BillingsOrderForwardTaxiTaxiRecalculateRequestNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.uuid,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createNodes = (
  nodes: BillingsOrderForwardTaxiTaxiRecalculateParamsNode[],
): BillingsOrderForwardTaxiTaxiRecalculateRequestNode[] => {
  return nodes.map(createNode);
};

const createRequest = (
  params: BillingsOrderForwardTaxiTaxiRecalculateParams,
): BillingsOrderForwardTaxiTaxiRecalculateRequest => {
  return {
    billingContributions: createContributions(params.billingContributions),
    billingNodes: createNodes(params.billingNodes),
    orderForwardingUuid: params.orderForwardingUuid,
  };
};

const billingsOrderForwardTaxiTaxiRecalculateParamsFactory = {
  createRequest,
};

export default billingsOrderForwardTaxiTaxiRecalculateParamsFactory;
